import React from "react";
import TextCard from "./TextCard";

interface Testimonial {
  name: string;
  description: string;
}

const testimonials: Testimonial[] = [
  {
    name: "OO 교수",
    description:
      "그동안 의료 분야에서 설문 조사를 설계하고 데이터를 수집·분석하는 데에 많은 시간과 인력이 필요했습니다. 특히 문항의 흐름이나 응답자 타겟 설정이 까다로워 어려움을 느끼곤 했는데, Aivy AI Studio를 도입한 이후 설문 제작부터 응답 분석까지의 모든 과정이 획기적으로 간소화되었습니다."
  },
  {
    name: "OOO 교육 담당자",
    description:
      "교육 과정이 끝날 때마다 필수적으로 수행해야 하는 만족도 조사 설문을 매 학기마다 새롭게 설계하고 분석하는 일이 큰 부담이었습니다. Aivy AI Studio는 단순히 설문을 자동으로 생성해주는 수준을 넘어, 목적에 맞는 문항 구성과 실시간 응답 분석 기능을 함께 제공해줍니다. 실제로 사용해보니 설문 관련 업무 시간이 절반 이상 줄어들었고, 보다 신속하고 정확하게 교육성과를 확인할 수 있게 되어 매우 만족스럽습니다."
  },
  {
    name: "OOO 대표",
    description:
      "당사에서는 고객사의 직무역량을 진단하고 그에 맞는 교육 컨설팅을 제공하는 서비스를 운영하고 있습니다. 기존에는 설문을 설계하고 결과를 분석하는 데 많은 시간이 소요되었지만, Aivy AI Studio를 도입한 후 전체 워크플로우가 획기적으로 개선되었습니다."
  },
  {
    name: "OOO 교수",
    description:
      "사회조사나 여론조사 프로젝트를 수행할 때 설문 초안을 구성하는 과정에서 많은 시행착오를 겪곤 했습니다. 그러나 Aivy AI Studio는 AI가 설문의 목적과 흐름을 스스로 파악하여 자연스럽고 논리적인 설문지를 생성해주어, 초기 설계 단계부터 높은 완성도를 갖출 수 있었습니다. 또한 실시간 분석 기능 덕분에 학생들과 함께 데이터를 즉시 시각화하고 토의할 수 있어 교육 현장에서도 매우 유용하게 활용하고 있습니다."
  },
  {
    name: "OOO 대표",
    description:
      "신제품 개발이나 마케팅 전략 수립을 위한 시장 조사를 자주 진행해야 하는 스타트업 입장에서 설문 설계는 늘 큰 과제였습니다. Aivy AI Studio는 설문 제작을 자동화해주고, 응답 데이터를 직관적으로 분석해주기 때문에 번거로운 과정을 줄이고 핵심 업무에 집중할 수 있게 해줍니다. 사용자의 피드백을 빠르게 수집하고 인사이트를 도출하는 과정이 훨씬 쉬워졌고, 덕분에 팀 전체의 실행력이 크게 향상되었습니다."
  },
  {
    name: "OO 교육 담당자",
    description:
      "매년 반복되는 직무교육 수요조사 및 사후 만족도 평가를 담당하면서, 늘 같은 작업을 반복해야 하는 데서 오는 피로감과 비효율을 느끼고 있었습니다. 하지만 Aivy AI Studio를 활용한 이후 설문 제작, 배포, 분석까지의 전 과정이 자동화되어 기존 업무 시간을 크게 단축할 수 있었고, 더욱 체계적이고 신뢰도 높은 결과를 얻을 수 있었습니다."
  },
  {
    name: "OOO 교육 담당자",
    description:
      "기존에는 설문조사를 위한 워드 작업과 엑셀 정리에만 며칠씩 걸렸습니다. 지금은 Aivy AI Studio 덕분에 클릭 몇 번으로 설문을 만들고, 실시간 응답 데이터를 바로 확인할 수 있어 전체 업무 속도가 압도적으로 빨라졌습니다. 다른 부서에서도 도입을 검토 중입니다."
  },
  {
    name: "OO 교수",
    description:
      "Aivy AI Studio는 설문 설계에 필요한 기본 구조를 자동으로 생성해주고, 문항 간의 논리적 흐름도 자연스럽게 연결되어 있어 매우 만족스럽습니다. 덕분에 수업 중 진행하는 학생 조사나 학습 피드백 설문을 빠르고 정확하게 만들 수 있었고, 결과 분석까지 실시간으로 제공되어 교육 연구에 큰 도움이 되고 있습니다."
  },
  {
    name: "OO 대표",
    description:
      "제품 개선을 위한 고객 피드백 수집이 늘 시간과 리소스를 많이 소모했는데, Aivy AI Studio를 통해 설문을 자동으로 생성하고, 수집된 데이터를 실시간으로 분석하면서 전체 업무 프로세스가 훨씬 유연해졌습니다. 인사이트를 빠르게 확보할 수 있어 의사결정이 훨씬 빨라졌습니다."
  },
  {
    name: "OO 대표",
    description:
      "고객 대상 만족도 조사와 사내 인식 조사를 정기적으로 진행하는 입장에서, 설문 설계와 데이터 분석의 반복은 큰 부담이었습니다. Aivy AI Studio는 이런 복잡한 과정을 AI가 알아서 처리해줘서 팀의 효율성과 생산성이 크게 향상되었고, 실제 고객 만족도도 높아졌습니다."
  },
];

interface TestimonialBannerProps {
  className?: string;
}

const TestimonialBanner = ({ className = "" }: TestimonialBannerProps) => {
  return (
    <div className={`w-full overflow-hidden relative ${className}`}>
      <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none"></div>

      <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none"></div>

      <div className="flex animate-scroll hover:animate-paused gap-6">
        <div className="flex gap-6 min-w-max">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="w-[240px] sm:w-[280px] md:w-[320px] lg:w-[360px] xl:w-[400px] flex-shrink-0">
              <TextCard
                name={testimonial.name}
                description={testimonial.description}
              />
            </div>
          ))}
        </div>
        {/* 무한 루프를 위한 복제 */}
        <div className="flex gap-6 min-w-max">
          {testimonials.map((testimonial, index) => (
            <div
              key={`duplicate-${index}`}
              className="w-[240px] sm:w-[280px] md:w-[320px] lg:w-[360px] xl:w-[400px] flex-shrink-0"
            >
              <TextCard
                name={testimonial.name}
                description={testimonial.description}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialBanner;
